export var debug=function debug(){if(process.env.NODE_ENV==='development'||process.env.REGION_ENV==='boe'){// console.log(...options); // eslint-disable-line
}};export default undefined;